// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e3144c24","453":"3c43e5e0","732":"a01e6b29","977":"b39ca83e"}[chunkId] + ".chunk.js";
};